module.exports = __webpack_public_path__ + "img/项目名.21f9b778.svg";